var _path, _path2, _path3, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWatersign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00206 36.8923H24.2422V31.8323H6.53207V9.0622C6.53207 7.66564 7.66551 6.53219 9.06208 6.53219H31.8322V24.2423H36.8922V4.00218C36.8922 2.60561 35.7588 1.47217 34.3622 1.47217H9.06208C4.87744 1.47217 1.47205 4.87756 1.47205 9.0622V34.3623C1.47205 35.7589 2.60549 36.8923 4.00206 36.8923Z",
    fill: "white",
    fillOpacity: 0.22
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.7823 1.47217H44.4822C43.0857 1.47217 41.9522 2.60561 41.9522 4.00218V36.8923H47.0122V6.53219H69.7823C71.1738 6.53219 72.3124 7.66564 72.3124 9.0622V31.8323H64.7223V36.8923H74.8424C76.2389 36.8923 77.3724 35.7589 77.3724 34.3623V9.0622C77.3724 4.87756 73.967 1.47217 69.7823 1.47217Z",
    fill: "white",
    fillOpacity: 0.22
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53207 69.7825V47.0124H31.8322V59.6625H36.8922V44.4824C36.8922 43.0858 35.7588 41.9524 34.3622 41.9524H4.00206C2.60549 41.9524 1.47205 43.0858 1.47205 44.4824V69.7825C1.47205 73.9672 4.87744 77.3726 9.06208 77.3726H37.1604V72.3125H9.06208C7.66551 72.3125 6.53207 71.174 6.53207 69.7825Z",
    fill: "white",
    fillOpacity: 0.22
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 79,
    height: 79
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 79H79V0H0V79Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8322 36.8921H36.8922V31.832H31.8322V36.8921Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.3124 47.0124H77.3724V41.9524H72.3124V47.0124Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6022 36.8921H59.6623V31.832H54.6022V36.8921Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.2524 52.0722H72.3124V47.0122H67.2524V52.0722Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.1924 47.0124H67.2524V41.9524H62.1924V47.0124Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1221 24.2016H24.2016V14.1221H14.1221V24.2016Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1221 64.7021H24.2016V54.6226H14.1221V64.7021Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6225 24.2016H64.7021V14.1221H54.6225V24.2016Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.0122 47.0124H54.6225V41.9524H44.4822C43.0857 41.9524 41.9522 43.0858 41.9522 44.4824V54.6227H47.0122V47.0124Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8423 57.1323H62.258V62.1923H72.3123V69.7824C72.3123 71.1739 71.1738 72.3124 69.7823 72.3124H54.6022V77.3724H69.7823C73.9669 77.3724 77.3723 73.967 77.3723 69.7824V59.6623C77.3723 58.2658 76.2389 57.1323 74.8423 57.1323Z",
    fill: "white",
    fillOpacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.1323 64.7024V54.6228H52.0723V62.1724H44.4822C43.0857 62.1724 41.9522 63.3058 41.9522 64.7024V77.3828H47.0122V67.2324H54.6023C55.9988 67.2324 57.1323 66.0989 57.1323 64.7024Z",
    fill: "white",
    fillOpacity: 0.22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWatersign);
export default __webpack_public_path__ + "static/media/watersign.c512ff25.svg";
export { ForwardRef as ReactComponent };